interface ApiErrorDetail {
    msg: string;
}

export default class ApiError extends Error {
    detail: ApiErrorDetail[];

    constructor(errors: ApiErrorDetail[] | string) {
        let message: string;
        if (Array.isArray(errors)) {
            message = errors.map((err) => `・${err.msg}`).join('\n');
        } else {
            message = `・${errors}`;
        }
        super(message);

        this.name = 'APIError';
        this.detail = Array.isArray(errors) ? errors : [{ msg: errors }];
    }
}
